import ReactDOM from 'react-dom';
import usePortal from 'hooks/usePortal';
import classNames from 'classnames';

function In({ target, children }) {
  const targetElement = usePortal(target);

  return ReactDOM.createPortal(children, targetElement);
}

function Out({ name }) {
  return (
    <div
      className={classNames('portal-target', `portal-target--${name}`)}
      id={name}
    />
  );
}

export default function Portal() {
  return null;
}

Portal.In = In;
Portal.Out = Out;
